// RissApp brand palette. `mark` is the green used to highlight cracks on
// photos; keep it in sync with `--mark-color` in global.css.
export const colors = {
  primary: "#7ddc9e", // brand mint
  ink: "#112127", // dark near-black teal — text
  mark: "#7ddc9e", // brand mint for crack marks
  deepGreen: "#165147", // dark end of the brand gradient — measure / edit icons
  gray: "#6f797d",
};
